var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox",on:{"click":function($event){return _vm.handleClick()}}},[_c('div',{staticClass:"check"},[_c('img',{style:({opacity: (!_vm.value ? '0' : '1'),}),attrs:{"src":_vm.imgCheck}})]),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }